import { FC, useState } from 'react'
import styled from 'styled-components'
import { Box, Flex } from '@/components/atoms/Grid'
import InformationContent from '@/components/atoms/informationContent'
import { lighten } from 'polished'

type AccordionItemProps = {
  title: string
  description: string
  contentProps?: Rest
}

const AccordionItem: FC<AccordionItemProps> = ({
  title,
  description,
  contentProps
}) => {
  const [opened, setOpened] = useState<boolean>(false)

  const toggle = () => {
    setOpened(!opened)
  }

  return (
    <StyledFlex flexDirection="column">
      <StyledBox onClick={toggle} opened={opened}>
        <AccordionIcon opened={opened} />
        {title}
      </StyledBox>
      {opened && (
        <Box className="information-page" {...contentProps}>
          <InformationContent html={description} />
        </Box>
      )}
    </StyledFlex>
  )
}

export default AccordionItem

const AccordionIcon = styled.span`
  &::before {
    content: ${({ opened }) => (opened ? "'-'" : "'+'")};
    display: inline-block;
    width: 12px;
    margin-left: -12px;
  }
`

const StyledBox = styled(Box)`
  color: ${({ theme, opened }) =>
    opened ? theme.colors.accent : theme.colors.onBackground};
  cursor: pointer;
`

const StyledFlex = styled(Flex)`
  padding: 24px;
  border: 1px solid ${({ theme }) => lighten(0.8, theme.colors.onBackground)};
  margin-bottom: 8px;
  border-radius: ${(props) => props.theme.borderRadius}px;
`
